/**
 * バリデーションエラー発生時に、最初のエラーフィールドにスクロール＆フォーカスする
 * @param errorFieldNames - エラーがあるフィールドの name または id のリスト
 * @param container - スクロール対象のコンテナ要素（省略時は document）
 */
export const scrollToFirstError = (
  errorFieldNames: string[],
  container?: HTMLElement | null
): void => {
  if (errorFieldNames.length === 0) return;

  // setTimeout で DOM 更新後に実行
  setTimeout(() => {
    for (const fieldName of errorFieldNames) {
      const element =
        document.getElementById(fieldName) ||
        document.querySelector(`[name="${fieldName}"]`);

      if (element) {
        if (container) {
          // コンテナ内でスクロール（Dialog等）
          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();
          const offset = elementRect.top - containerRect.top - containerRect.height / 2;
          container.scrollBy({ top: offset, behavior: 'smooth' });
        } else {
          // ページ全体でスクロール
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // フォーカス可能な要素ならフォーカス
        if (element instanceof HTMLElement && typeof element.focus === 'function') {
          // スクロールのアニメーション後にフォーカス
          setTimeout(() => element.focus(), 300);
        }
        break; // 最初のエラーフィールドだけ処理
      }
    }
  }, 100);
};
